"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldMapPreview = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var doshx_controls_web_1 = require("doshx_controls_web");
var useSearchDebounce_1 = require("../../../../../../../hooks/useSearchDebounce");
var map_to_target_1 = __importDefault(require("../../helpers/map_to_target"));
var orders_1 = require("../../../../../../../reducers/slices/orders/orders");
var order_list_thunk_1 = require("../../../../../../../reducers/slices/orders/thunks/order_list_thunk");
var react_2 = require("@nextui-org/react");
var FieldMapPreview = function (_a) {
    var fields = _a.fields;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.orderState; }), orders = _b.orders, selectedOrder = _b.selectedOrder, pagination = _b.pagination;
    var _c = (0, useSearchDebounce_1.useSearchDebounce)(500), orderSearchString = _c[0], setOrderSearchString = _c[1];
    var _d = (0, react_1.useState)(""), sample = _d[0], setSample = _d[1];
    var _onSearchChange = function (searchString) {
        setOrderSearchString(searchString);
    };
    var _onOrderChange = function (order) {
        dispatch((0, orders_1.setSelectedOrder)(order));
    };
    (0, react_1.useEffect)(function () {
        if (!orders.length) {
            dispatch((0, order_list_thunk_1.order_list_thunk)(__assign(__assign({}, pagination), (orderSearchString && { search_string: orderSearchString }))));
        }
        return function () {
            dispatch((0, orders_1.setSelectedOrder)(null));
        };
    }, []);
    (0, react_1.useEffect)(function () {
        if (orderSearchString) {
            dispatch((0, order_list_thunk_1.order_list_thunk)(__assign(__assign({}, pagination), (orderSearchString && { search_string: orderSearchString }))));
        }
    }, [orderSearchString]);
    (0, react_1.useEffect)(function () {
        if (selectedOrder) {
            var data = (0, map_to_target_1.default)(fields, selectedOrder);
            setSample(JSON.stringify(data, null, 2));
        }
    }, [selectedOrder, fields]);
    (0, react_1.useEffect)(function () {
        if (orders.length) {
            dispatch((0, orders_1.setSelectedOrder)(orders[0]));
        }
    }, [orders]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsx)(react_2.Autocomplete, __assign({ label: "Order", size: "sm", defaultItems: orders, 
                // selectedKey={selectedOrder?._id}
                // onInputChange={handleInputChange}
                onSelectionChange: function (key) {
                    var selected = orders.find(function (order) { return order._id === key; });
                    if (selected)
                        _onOrderChange(selected);
                }, classNames: {
                    base: "border-borders",
                } }, { children: function (item) { return ((0, jsx_runtime_1.jsx)(react_2.AutocompleteItem, __assign({ textValue: item.code }, { children: item.code }), item._id)); } })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.TextAreaControl, { borderColor: "border-borders", labelColor: "text-labelText", textColor: "text-inputText", value: sample, disabled: true })] })));
};
exports.FieldMapPreview = FieldMapPreview;
